const donateLinkByLocale = {
  en: '/en/donate',
  pt: '/pt/doacao',
  es: '/es/dona',
} as const;

export function getDonateRoutePath<T extends UserLocale>(locale: T) {
  return donateLinkByLocale[locale];
}
